import {
  Mix_Content_Status_Enum,
  Mix_Content_Tag_Enum_Enum,
  Order_By,
} from "graphql/generated";
import { IndexPageContentSection } from "types/app";

export const LIMIT = {
  default: 16,
  original: 4,
};

export const buildQueryVariables = (
  section: IndexPageContentSection | null,
  tags: Mix_Content_Tag_Enum_Enum[] | null,
  limit: number,
): MixContentQueryVariables => ({
  where: {
    status: {
      _eq: Mix_Content_Status_Enum.Published,
    },
    ...(tags && tags.length > 0
      ? {
          mix_content_tags: {
            mix_content_tag_enum: {
              value: { _in: tags },
            },
          },
        }
      : {}),
    ...(section === "original"
      ? {
          isoriginal: {
            _eq: true,
          },
        }
      : section === "recent"
      ? {
          isoriginal: {
            _eq: false,
          },
        }
      : {}),
  },
  orderBy: [{ updatedate: Order_By.Desc }, { id: Order_By.Asc }],
  limit,
  offset: 0,
});
